module.exports = __webpack_public_path__ + "static/img/wing_950.b1723af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/wing_950.jpg
// module id = 2iya
// module chunks = 0